import { BrandsDashboardCampaigns } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchBrandsDashboardCampaigns = (businessAccountId: string): Promise<BrandsDashboardCampaigns> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BrandsDashboardCampaigns>(
        `business-accounts/${businessAccountId}/brands/dashboard-campaigns`,
    );

export const CancelableBrandsDashboardCampaignGateway = {
    cancelableFetchBrandsDashboardCampaigns,
};
